import React, { use, useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
//UI
import { DangerButton, InfoButton, SuccessButton } from "../../../../ui/buttons/Button";
import { Input, Radio, SearchInput, Textarea } from "../../../../ui/inputs/Input";
import moment from "moment";
import { Mensaje } from "../../../mensajes2";
import CatalogoUbicacionBien from "../../../../catalogos/catalogoUbicacionBien";
const op = require("../../../../modulos/datos");

export default function ListadosIncorporacionesBienes({ show, setShow, setTabla }) {
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const token = localStorage.getItem("jwtToken");

  const txtPorDependencia = useRef();
  const txtTodasDependencia = useRef();
  const txtId = useRef();
  const txtDescripcion = useRef();
  const txtDesdeFecha = useRef();
  const txtHastaFecha = useRef();

  const [mostrarCatalogo, setMostrarCatalogo] = useState(false);
  const [valdepen, setValdepen] = useState(0);
  const [desdeFecha, setDesdeFecha] = useState("");
  const [hastaFecha, setHastaFecha] = useState("");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const seleccionarDependencia = async (idubi) => {
    const campos = "*";
    const nomtab = "ubicacionbien";
    const nomid = "idubicacionbien";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${idubi}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            console.log(data);
            txtId.current.value = data.idubicacionbien;
            txtDescripcion.current.value = data.descripcion;
            setMostrarCatalogo(false);
          } else {
            setActivate(false);
            txtId.current.value = "";
            txtDescripcion.current.value = "";
            txtId.current.focus();
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe una Dependencia con este código.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  useEffect(() => {
    if (txtPorDependencia.current) {
      txtPorDependencia.current.checked = false;
    }
    if (txtTodasDependencia.current) {
      txtTodasDependencia.current.checked = true;
    }
  }, [show]);

  const imprimirGeneral = () => {
    try {
      const storedData = localStorage.getItem("post");
      if (!storedData) {
        console.error("No hay datos en localStorage");
        return;
      }
      const data = JSON.parse(storedData);
      const reporte = "Bienes_Resumen_Cuentas";
      let semestre = "";
      let val1 = moment(desdeFecha).format("DD-MM-YYYY");
      let val2 = moment(hastaFecha).format("DD-MM-YYYY");
      let val3 = val1.substring(6, 10) + "-06-30";
      let sql = " Between '" + val1 + "' and '" + val2 + "'";
      let sql1 = "'" + val1 + "'";
      let sql2 = " DESDE " + val1 + "  HASTA " + val2 + " ";
      let sql3 = txtId.current.value;

      let fechaini = moment(val1, "DD-MM-YYYY");
      let fechafin = moment(val3, "DD-MM-YYYY");

      if (fechaini.diff(fechafin, 'days') > 0) {
        semestre = "Segundo Semestre " + desdeFecha.substring(6, 10);
      } else {
        semestre = "Primer Semestre " + desdeFecha.substring(6, 10);
      }

      if (val1 === val2) {
        sql2 = " DEL DIA " + val1;
      }

      let spiritu = data.espiritu.trim();
      let nombreorg = data.nombreorg.trim();
      let rif = data.riforg.trim();

      window.open(
        op.reportes +
        "/bienes?" +
        "reporte=" +
        reporte +
        "&ubicacion=" +
        sql3 +
        "&CONDICION=" +
        sql +
        "CONDICION1" +
        sql1 +
        "&ESTADO=" +
        estado +
        "&MUNICIPIO=" +
        municipio +
        "&SEMESTRE=" +
        semestre +
        "&ORGANISMO=" +
        nombreorg +
        "&TITFEC=" +
        sql2 +
        "&ORGANISMO=" +
        nombreorg +
        "&RIF=" +
        rif +
        "&VIENE=" +
        spiritu,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      console.error("Error en imprimirGeneral:", error);
    }
  };

  const onChangeFecha = (e) => {
    if (e.target.name === 'desde') {
      setDesdeFecha(e.target.value);
    } else if (e.target.name === 'hasta') {
      setHastaFecha(e.target.value);
    }
  }

  const onChangeValidar = async () => {
    let sigue = true;

    if (txtDesdeFecha.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar la fecha desde.`,
        icono: "informacion",
      });
      sigue = false;
      txtDesdeFecha.current.focus();
    } else if (txtHastaFecha.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar la fecha hasta.`,
        icono: "informacion",
      });
      sigue = false;
      txtHastaFecha.current.focus();
    } else if (txtPorDependencia.current.checked && txtId.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar la dependencia.`,
        icono: "informacion",
      });
      sigue = false;
      txtId.current.focus();
    }

    if (sigue) {
      imprimirGeneral();
    }
  };

  const blanquear = () => {
    txtDescripcion.current.value = "";
    txtId.current.value = "";
    txtTodasDependencia.current.checked = false;
    txtPorDependencia.current.checked = false;
    txtDesdeFecha.current.value = "";
    txtHastaFecha.current.value = "";
    setMostrarCatalogo(false);
    setValdepen(0);
    setDesdeFecha("");
    setHastaFecha("");
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
  };

  const onChangeDependencia = (e) => {
    if (e.target.name === 'dependencia') {
      if (txtPorDependencia.current.checked) {
        setValdepen(1);
      } else {
        setValdepen(0);
        txtId.current.value = "";
        txtDescripcion.current.value = "";
      }
    }
  }

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Resumen de las Cuentas de Bienes Muebles</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <fieldset className="col-12 m-0 mb-2 p-2 d-flex gap-2 border-azul rounded row d-flex justify-content-around">
          <legend className="float-none w-auto m-0">Buscar por:</legend>
          <div className="col-4 m-0 p-0">
            <Input label='Desde la Fecha:' type='date' ref={txtDesdeFecha} name='desde' value={desdeFecha} onChange={onChangeFecha} />
          </div>
          <div className="col-4 m-0 p-0">
            <Input label='Hasta la Fecha:' type='date' ref={txtHastaFecha} name='hasta' value={hastaFecha} onChange={onChangeFecha} />
          </div>
        </fieldset>
        <div className="col-12 m-0 p-0 d-flex gap-2 d-flex justify-content-around">
          <div className="col-auto m-0 p-0">
            <Radio label='Seleccionar Dependencia' ref={txtPorDependencia} name='dependencia' id='dependencia1' onChange={onChangeDependencia} />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio label='Todas las Dependencia' ref={txtTodasDependencia} name='dependencia' id='dependencia2' onChange={onChangeDependencia} />
          </div>
        </div>
        <fieldset className="col-12 m-0 p-2 d-flex gap-2 border-azul rounded">
          <legend className="float-none w-auto m-0">Dependencias</legend>
          <div className="col-3 m-0 p-0">
            <SearchInput
              ref={txtId}
              disabled
              label="CÓDIGO:"
              name="id"
              onClickButton={() => setMostrarCatalogo(true)}
              disabledButton={valdepen === 0 ? true : false}
            />
          </div>
          <Input label='Descripción:' disabled ref={txtDescripcion} />
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-12 d-flex m-auto justify-content-end">
          <div className="m-1 p-0">
            <InfoButton
              icon="fas fa-print"
              onClick={() => onChangeValidar()}
            >
              Imprimir
            </InfoButton>
          </div>
          <div className="m-1 p-0">
            <DangerButton onClick={() => salir()}>
              Cancelar
            </DangerButton>
          </div>
        </div>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
        }}
      />
      <CatalogoUbicacionBien show={mostrarCatalogo}
        setShow={setMostrarCatalogo}
        onHideCancelar={() => setMostrarCatalogo(false)}
        seleccionarDependencia={seleccionarDependencia}
      />
    </Modal>
  );
}